interface MedicalDisclaimerProps {
  lang?: "tr" | "en";
}

const CONTENT = {
  tr: {
    aria: "Tıbbi bilgilendirme uyarısı",
    title: "Tıbbi Bilgilendirme Uyarısı",
    body: "Bu içerik yalnızca genel bilgilendirme amacıyla hazırlanmıştır ve tıbbi tavsiye, tanı ya da tedavi yerine geçmez. Her hastanın öyküsü, muayene bulguları ve laboratuvar sonuçları farklı olduğundan; belirtiler, tanı ve tedavi seçenekleri hakkında kesin bir yargıya ancak bizzat yapılan hekim muayenesi ve gerekli tetkikler sonrasında varılabilir. Sağlığınıza ilişkin herhangi bir karar almadan önce mutlaka bir kadın hastalıkları ve doğum uzmanına danışınız. Yazının hazırlanmasında güncel tıbbi kaynaklardan yararlanılmış olup, tıp bilimindeki gelişmelere bağlı olarak bilgilerin zaman içinde güncellenmesi gerekebilir. Op. Dr. Sadık Kükrer ve bu web sitesi, buradaki bilgilerin muayene olmaksızın uygulanmasından doğabilecek sonuçlardan sorumlu tutulamaz.",
  },
  en: {
    aria: "Medical disclaimer",
    title: "Medical Disclaimer",
    body: "This content is provided for general informational purposes only and is not a substitute for professional medical advice, diagnosis, or treatment. Because every patient's history, examination findings, and laboratory results differ, a definitive judgement about symptoms, diagnosis, or treatment options can only be made after an in-person consultation with a qualified physician and any necessary investigations. Always seek the advice of a qualified obstetrician and gynaecologist before making any decision regarding your health. This article has been prepared using current medical sources; as medical science evolves, the information may need to be updated over time. Op. Dr. Sadık Kükrer and this website cannot be held responsible for any consequences arising from the application of this information without an in-person medical examination.",
  },
} as const;

export function MedicalDisclaimer({ lang = "tr" }: MedicalDisclaimerProps) {
  const t = CONTENT[lang];
  return (
    <aside
      role="note"
      aria-label={t.aria}
      className="mt-16 rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface-alt)] p-6 text-sm leading-relaxed text-[color:var(--muted-foreground)]"
    >
      <p className="mb-2 font-display text-base font-semibold text-[color:var(--foreground)]">
        {t.title}
      </p>
      <p>{t.body}</p>
    </aside>
  );
}
